<script>
  import { selectedLanguage } from "../etc/store.js"

  const handleRedirect = (where) => {
    if (where == "home") {
      location.assign("/")
    } else {
      location.assign("/account")
    }
  }
</script>

{#if $selectedLanguage == "TW"}
  <main>
    <div class="row">
      <div class="col s12 m12 l12">
        <div class="card-panel teal lighten-5">
          <h4>謝謝您，有空歡迎您再回來【XiYi 習易網】看看！</h4>
          <br />
          <div class="btn-row center">
            <button
              class="btn btn-large"
              on:click={() => handleRedirect("home")}>回主頁</button
            >
            <button
              class="btn btn-large orange"
              on:click={() => handleRedirect("account")}>回帳戶</button
            >
          </div>
        </div>
      </div>
    </div>
  </main>
{:else}
  <main>
    <div class="row">
      <div class="col s12 m12 l12">
        <div class="card-panel teal lighten-5">
          <h4>谢谢您，有空欢迎您再回来【XiYi 习易网】看看！</h4>
          <br />
          <div class="btn-row center">
            <button
              class="btn btn-large"
              on:click={() => handleRedirect("home")}>回主页</button
            >
            <button
              class="btn btn-large orange"
              on:click={() => handleRedirect("account")}>回帐户</button
            >
          </div>
        </div>
      </div>
    </div>
  </main>
{/if}

<style>
  .btn {
    margin-left: 10px;
    margin-right: 10px;
  }
</style>
